import { render, staticRenderFns } from "./ProjectPropositionsRow.vue?vue&type=template&id=6cca7b48&scoped=true&"
import script from "./ProjectPropositionsRow.vue?vue&type=script&lang=js&"
export * from "./ProjectPropositionsRow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPropositionsRow.vue?vue&type=style&index=0&id=6cca7b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca7b48",
  null
  
)

export default component.exports